export const alphabeticalSort = (sortingArray, sortOrder) =>
  [...sortingArray].sort((a, b) => {
    if (sortOrder === "a") {
      return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
    } else if (sortOrder === "z") {
      return a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1;
    }
  });
